// Mashmari - Content model (frontend mock data, factual from provided brochures)

export let brand = {
  name: 'MASHMARI',
  hindi: 'माशमारी',
  tagline: 'Transforming Learning. Connecting Communities. Building Digital Trust.',
  logoUrl: 'https://customer-assets-lqy194kg.emergentagent.net/job_mashmari-redesign/artifacts/logo_placeholder',
};

export let nav = [
  { label: 'Home', href: '/' },
  {
    label: 'Transform Education',
    href: '/transform',
    children: [
      { label: 'School Transformation', href: '/transform/school', desc: 'Move from transmission to construction in the real classroom.' },
      { label: 'Digital TLM Engine', href: '/transform/digital-tlm', desc: 'Seven engines that turn curriculum into classroom-ready material.' },
      { label: 'Smart ECCE / Digital Anganwadi', href: '/transform/smart-ecce', desc: 'Aadharshila-aligned foundational learning, delivered daily.' },
      { label: 'Village School Transformation', href: '/transform/village-schools', desc: 'Infrastructure-light digital learning for village schools.' },
      { label: 'Remote & Autonomous Classrooms', href: '/transform/remote-classrooms', desc: 'Four delivery modes for connected and offline contexts.' },
    ],
  },
  {
    label: 'Technology',
    href: '/technology',
    children: [
      { label: 'Learning Intelligence', href: '/technology/learning-intelligence', desc: 'Curriculum ingestion, competency mapping and lesson intelligence.' },
      { label: 'Learning Platforms', href: '/technology/platforms', desc: 'LMS, courses, assessments and learner progress.' },
      { label: 'Classroom Delivery', href: '/technology/classroom-delivery', desc: 'Connected, autonomous, remote and offline-first execution.' },
      { label: 'Evidence & Analytics', href: '/technology/evidence', desc: 'Classroom evidence, dashboards and intervention intelligence.' },
      { label: 'Edge Infrastructure', href: '/technology/edge', desc: 'Local delivery and resilience where connectivity is scarce.' },
      { label: 'Secure Connectivity', href: '/technology/secure-connectivity', desc: 'Policy-controlled broadband and network-level protection.' },
    ],
  },
  { label: 'NetRakshak', href: '/netrakshak' },
  { label: 'Projects', href: '/projects' },
  { label: 'Research & Standards', href: '/research' },
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '/contact' },
];

// Homepage — three transformation cards
export let transformCards = [
  {
    id: 'schools',
    kicker: '01 · Schools',
    title: 'Transform Schools',
    body: 'From curriculum delivery to learner-centred, evidence-led classroom transformation.',
    href: '/transform/school',
  },
  {
    id: 'grassroots',
    kicker: '02 · Grassroots',
    title: 'Transform Grassroots Learning',
    body: 'Digital ECCE, village learning and autonomous classrooms designed for real-world infrastructure.',
    href: '/transform/smart-ecce',
  },
  {
    id: 'communities',
    kicker: '03 · Communities',
    title: 'Secure Connected Communities',
    body: 'Subscriber safety, network intelligence and cybersecurity built into broadband infrastructure.',
    href: '/netrakshak',
  },
];

// Transformation chain
export let transformationChain = [
  'Curriculum', 'Competencies', 'Learning Outcomes', 'Content', 'TLM',
  'Lesson', 'Teacher', 'CLASSROOM EXECUTION', 'Student Response', 'Assessment', 'Adaptation',
];

// Seven engines
export let sevenEngines = [
  { id: '01', title: 'Curriculum & Knowledge Intelligence', body: 'Structure textbooks, curricula and authoritative educational knowledge into machine-usable learning intelligence.' },
  { id: '02', title: 'Competency & Learning Intelligence', body: 'Map curriculum to competencies, learning outcomes and educational objectives.' },
  { id: '03', title: 'Lesson Intelligence', body: 'Support teachers in creating competency-based, differentiated, context-aware lesson plans.' },
  { id: '04', title: 'Digital TLM Factory', body: 'Design, generate, curate, review and quality-assure Teaching Learning Materials using AI plus human expertise.' },
  { id: '05', title: 'Teacher Capability Engine', body: 'Train, scaffold, coach and support teachers while enabling co-creation.' },
  { id: '06', title: 'Classroom Delivery Engine', body: 'Make approved lessons and TLMs reliably available in classrooms, including low-connectivity and offline environments.' },
  { id: '07', title: 'Evidence & Improvement Engine', body: 'Observe classroom implementation, learning, engagement and assessment evidence and feed the findings into the next improvement cycle.' },
];

export let conventionalVsTransformed = [
  ['Learning as transmission', 'Learning as construction'],
  ['Teacher as instructor', 'Teacher as facilitator / co-inquirer'],
  ['“What is the right answer?”', '“What do I think, and what evidence supports it?”'],
  ['Chapter-based progression', 'Unit / inquiry-based learning'],
  ['Factual recall', 'Conceptual understanding'],
  ['Correctness-oriented literacy', 'Expression-centric literacy'],
  ['Algorithm-first mathematics', 'Conceptual reasoning'],
  ['Episodic, marks-focused assessment', 'Embedded, continuous assessment'],
  ['Teacher-centred environment', 'Active, conversational, student-owned learning'],
];

export let journeyStages = ['Discovery', 'Pilot', 'Refinement', 'Validation', 'Demonstration', 'Scale'];

export let implementationSteps = [
  { id: '01', title: 'Engage the Experts', body: 'Identify subject and classroom experts.' },
  { id: '02', title: 'Define Success', body: 'Agree classroom practices, outcomes and rubrics covering teacher practice, student learning and engagement.' },
  { id: '03', title: 'Review and Upgrade', body: 'Review existing TLMs, establish a quality benchmark and upgrade the initial corpus.' },
  { id: '04', title: 'Prepare Teachers and Pipeline', body: 'Train teachers, demonstrate improved TLMs, establish review/approval workflows and create a rolling content pipeline.' },
  { id: '05', title: 'Co-create and Execute', body: 'Teachers co-create lessons and TLMs, deploy them through the approved workflow and use them in real classrooms.' },
  { id: '06', title: 'Review and Refine', body: 'Review against rubrics and improve the seven engines using actual classroom evidence.' },
  { id: '07', title: 'Verify and Decide', body: 'Undertake independent/structured verification where applicable and let the institution decide whether to close, refine or scale the programme.' },
];

// ECCE — from Digital Anganwadi brochure (Sep 2026)
export let ecceStats = [
  { value: '82+', label: 'Anganwadis Reached', sub: 'across three deployments' },
  { value: '3', label: 'States, One Model', sub: 'Haryana, Maharashtra, Telangana' },
  { value: '15,000+', label: 'Lessons Delivered', sub: 'in the Ambala district pilot alone' },
];

export let ecceOutcomes = [
  { audience: 'CHILDREN', title: 'Joyful, Aadharshila-Aligned Learning', body: 'Songs, stories and activities mapped to all nine NCF-FS Aadharshila competencies keep children engaged and genuinely school-ready.' },
  { audience: 'WORKER', title: 'Worker Empowerment, Every Day', body: '131 Aadharshila-aligned activities across 48 weeks are scheduled and delivered automatically — making every Anganwadi Worker a confident educator.' },
  { audience: 'COMMUNITY', title: 'Community Trust & Better Attendance', body: 'Joyful digital classrooms draw children back and build parents’ confidence in the Anganwadi as a place of real learning.' },
  { audience: 'WCDD', title: 'Playback Dashboard & Evidence', body: 'Every lesson played is logged. Supervisors and donors see real classroom evidence daily — not an annual report.' },
  { audience: 'GOVERNMENT', title: 'Central Visibility & Remote Management', body: 'Content, monitoring and worker training are managed centrally, giving departments live, state-wide oversight from one dashboard.' },
  { audience: 'CSR DONOR', title: 'Impact Assurance & CSR Branding', body: 'Donor acknowledgement, documentation and evidence-based reporting turn every centre into a visible, accountable CSR outcome.' },
];

export let ecceDeployments = [
  { location: 'Satnavari, Nagpur · Maharashtra', scale: '1 Anganwadi Centre', body: 'India’s First Smart Intelligent Village ECCE deployment. Community adoption, parent engagement and worker confidence were transformed at a single site.', evidence: 'Certificate of Recognition — Chief Minister of Maharashtra' },
  { location: 'Secunderabad · Telangana', scale: '14 Anganwadi Centres', body: 'Administrative approval on record for a full-stack BSNL–Mashmari CSR deployment across all seven Assembly constituencies: equipment, curriculum-aligned content, connectivity, worker training and live monitoring, reaching 500+ children daily.' },
  { location: 'Ambala · Haryana', scale: '67 Anganwadi Centres', body: 'Woman & Child Development Department government pilot, PIB endorsed: 15,000+ structured lessons delivered with zero curriculum drift, remote WCDD supervision and execution led entirely by trained local youth.', evidence: 'Evaluation Report: WCD Department, Haryana, with BSNL · Ref. MCSA20251229001' },
];

export let eccePillars = [
  { title: 'Mashmari Doot', body: 'Compact, rugged projector and speaker. Offline-first — no daily internet needed. One button starts the full lesson.' },
  { title: 'Digital Lesson Library', body: '150+ curriculum-aligned videos covering 131 Aadharshila activities across all nine NCF-FS competencies, 48 weeks.' },
  { title: 'Cloud CMS & Remote Push', body: 'Centrally managed content library. New lessons push to every connected centre simultaneously from one dashboard.' },
  { title: 'Live Monitoring Dashboard', body: 'Real-time playlogs and activity dashboards — supervisors see every lesson delivered, from anywhere.' },
  { title: 'AI Lesson Planner', body: 'Automated daily scheduling. The right lesson plays at the right time — zero planning burden on the Anganwadi Worker.' },
  { title: 'Mobile Worker Training', body: 'AWW upskilling via mobile app. Available anytime, anywhere — no classroom needed for the trainer.' },
];

// Village schools — Saarthak journey
export let villageJourney = [
  { n: 1, title: 'School Identity & Onboarding', body: 'School, staff, learners and classroom devices.' },
  { n: 2, title: 'Attendance', body: 'Digital/biometric learner presence where deployed.' },
  { n: 3, title: 'Adaptive Baseline Assessment', body: 'Establish the learner or cohort’s current competency.' },
  { n: 4, title: 'Learning Path', body: 'Build a curriculum trajectory based on objectives, level and pace.' },
  { n: 5, title: 'Curriculum & Playlist', body: 'Match learning objectives with appropriate courses and classroom content.' },
  { n: 6, title: 'Classroom Execution', body: 'Teacher-led or autonomous/offline delivery according to ground reality.' },
  { n: 7, title: 'Track & Report', body: 'Combine delivery, learner activity and assessment evidence to guide intervention.' },
];

// Remote classrooms
export let classroomModes = [
  { title: 'Connected Classroom', body: 'Teacher-supported digital lesson delivery.' },
  { title: 'Autonomous Classroom', body: 'Pre-approved lessons and learning assets delivered locally even when daily internet or a specialist teacher is unavailable.' },
  { title: 'Edge-enabled Classroom', body: 'Content, applications and services available close to the learner for resilience and reduced dependency on cloud connectivity.' },
  { title: 'Remote Classroom', body: 'Teaching expertise, content and learning services made available beyond the physical location of the educator.' },
];

// NetRakshak
export let netRakshakPillars = [
  { id: '01', title: 'Customer Service', body: 'Parental controls and per-device management enabling differentiated broadband services.' },
  { id: '02', title: 'Network Intelligence', body: 'Behavioural visibility into CPE and connected-device activity across the network.' },
  { id: '03', title: 'Cybersecurity Layer', body: 'Network-level policy enforcement designed to provide consistent protection independent of individual endpoint applications.' },
];

export let netRakshakArchitecture = [
  'Subscriber Intent / Policy',
  'Service Provider Platform',
  'Policy & Intelligence Layer',
  'CPE / Router Agent',
  'Connected Devices',
];

// Technology capabilities
export let techCapabilities = [
  { id: 'learning-intelligence', title: 'Learning Intelligence', body: 'Curriculum ingestion, educational knowledge repositories, competency mapping, lesson intelligence and adaptive pathways.' },
  { id: 'platforms', title: 'Learning Platforms', body: 'LMS, courses, assessments, assignments, learner progress and teacher activity.' },
  { id: 'content-tlm', title: 'Content & TLM', body: 'Authoring, media, TLM generation, quality workflows, curriculum alignment and playlists.' },
  { id: 'classroom-delivery', title: 'Classroom Delivery', body: 'Connected, autonomous, remote and offline-first classroom execution.' },
  { id: 'edge', title: 'Edge Infrastructure', body: 'Local delivery, resilience and operation in constrained-connectivity environments.' },
  { id: 'evidence', title: 'Evidence & Analytics', body: 'Learner evidence, classroom events, assessment, dashboards and intervention intelligence.' },
  { id: 'identity', title: 'Identity, Attendance & Administration', body: 'School/learner onboarding, role-based access, attendance and operational workflows.' },
  { id: 'secure', title: 'Secure Connectivity', body: 'Policy-controlled broadband, CPE intelligence and network-level cybersecurity.' },
];

// Contact
export let contactInfo = {
  address: 'Noida : B - 11 GF, Sector 4, 201301',
  phone: '+91 9818088726',
  email: 'info@mashmari.in',
  workAddresses: [
    'Noida : B - 11 GF, Sector 4, 201301',
    'Kolkata : 5th Floor, Premises no. 06-315, P.S. New Town, District-North 24 Parganas, Kolkata-700060',
  ],
  registeredAddress: 'New Delhi : 1372, Sector A, Pocket B, Vasant Kunj, New Delhi - 110070',
  cin: '',
  openingHours: 'Mon – Fri',
  social: { instagram: '#', linkedin: '#' },
};

// Photography — editable from the admin Content Studio (upload or paste a URL)
export let siteImages = {
  homeBand: 'https://images.unsplash.com/photo-1573894999291-f440466112cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxJbmRpYW4lMjBnb3Zlcm5tZW50JTIwc2Nob29sJTIwY2xhc3Nyb29tJTIwc3R1ZGVudHMlMjB0ZWFjaGVyfGVufDB8fHx8MTc5MDE1NzA5Mnww&ixlib=rb-4.1.0&q=85',
  schoolTransformation: 'https://images.unsplash.com/photo-1522661067900-ab829854a57f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxJbmRpYW4lMjBnb3Zlcm5tZW50JTIwc2Nob29sJTIwY2xhc3Nyb29tJTIwc3R1ZGVudHMlMjB0ZWFjaGVyfGVufDB8fHx8MTc5MDE1NzA5Mnww&ixlib=rb-4.1.0&q=85',
  digitalTlm: 'https://images.unsplash.com/photo-1758270704925-fa59d93119c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHx0ZWFjaGVyJTIwdHJhaW5pbmclMjB3b3Jrc2hvcCUyMGFkdWx0cyUyMGNsYXNzcm9vbXxlbnwwfHx8fDE3OTAxNTcwOTJ8MA&ixlib=rb-4.1.0&q=85',
  smartEcce: 'https://customer-assets-lqy194kg.emergentagent.net/job_mashmari-redesign/artifacts/qnqt4a9z_AWC%20Amabala%20Teaching%20with%20Doot%20classroom%20high%20quality%20image.png',
  villageSchools: 'https://images.pexels.com/photos/35558791/pexels-photo-35558791.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  remoteClassrooms: '/transform/remote-classrooms.png',
  netRakshak: 'https://images.unsplash.com/photo-1476703993599-0035a21b17a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxmYW1pbHklMjBob21lJTIwaW50ZXJuZXQlMjByb3V0ZXIlMjBicm9hZGJhbmQlMjBzYWZldHl8ZW58MHx8fHwxNzkwMTU3MDkyfDA&ixlib=rb-4.1.0&q=85',
};

export let footerLinks = [
  { label: 'Statutory Disclosures', href: '/statutory-disclosures' },
  { label: 'Terms & Conditions', href: '#' },
  { label: 'Privacy Policy', href: '#' },
  { label: 'Request Data Deletion', href: '#' },
];

export let evidenceStrip = [
  { title: 'Schools', body: 'Teacher and classroom transformation.' },
  { title: 'Digital ECCE', body: 'Anganwadi deployments and structured foundational learning.' },
  { title: 'Village Learning', body: 'Infrastructure-light digital school activation.' },
  { title: 'Remote Classroom', body: 'Connected and autonomous delivery.' },
  { title: 'Standards', body: 'Remote classroom and emerging digital architecture work.' },
  { title: 'Secure Broadband', body: 'NetRakshak customer safety, intelligence and cybersecurity.' },
];

// Statutory disclosures — annual returns (Form MGT-7 / MGT-7A) published under
// Section 92(3) of the Companies Act, 2013. Editable from the admin Content Studio.
export let annualReturns = [
  {
    financialYear: '2024-25',
    form: 'Form MGT-7A',
    filedOn: '',
    fileUrl: '',
    note: '',
  },
];

// --- CMS wiring -------------------------------------------------------------
// Editable sections are live bindings (export let) so content fetched from the
// backend at boot replaces these defaults across every page.
const setters = {
  brand: (v) => { brand = v; },
  transformCards: (v) => { transformCards = v; },
  transformationChain: (v) => { transformationChain = v; },
  sevenEngines: (v) => { sevenEngines = v; },
  conventionalVsTransformed: (v) => { conventionalVsTransformed = v; },
  journeyStages: (v) => { journeyStages = v; },
  implementationSteps: (v) => { implementationSteps = v; },
  ecceStats: (v) => { ecceStats = v; },
  ecceOutcomes: (v) => { ecceOutcomes = v; },
  ecceDeployments: (v) => { ecceDeployments = v; },
  eccePillars: (v) => { eccePillars = v; },
  villageJourney: (v) => { villageJourney = v; },
  classroomModes: (v) => { classroomModes = v; },
  netRakshakPillars: (v) => { netRakshakPillars = v; },
  netRakshakArchitecture: (v) => { netRakshakArchitecture = v; },
  techCapabilities: (v) => { techCapabilities = v; },
  contactInfo: (v) => { contactInfo = v; },
  evidenceStrip: (v) => { evidenceStrip = v; },
  siteImages: (v) => { siteImages = v; },
  annualReturns: (v) => { annualReturns = v; },
};

export const editableSections = Object.keys(setters);

export const sectionMeta = {
  siteImages: { label: 'Photography', page: 'Home & section pages' },
  brand: { label: 'Brand & Tagline', page: 'Global' },
  transformCards: { label: 'Homepage Transformation Cards', page: 'Home' },
  transformationChain: { label: 'Transformation Chain', page: 'Home' },
  evidenceStrip: { label: 'Evidence Strip', page: 'Home' },
  sevenEngines: { label: 'Seven Engines', page: 'Digital TLM' },
  implementationSteps: { label: 'Implementation Steps', page: 'Digital TLM' },
  conventionalVsTransformed: { label: 'Conventional vs Transformed', page: 'School Transformation' },
  journeyStages: { label: 'Journey Stages', page: 'School Transformation' },
  ecceStats: { label: 'ECCE Statistics', page: 'Smart ECCE' },
  ecceOutcomes: { label: 'ECCE Outcomes', page: 'Smart ECCE' },
  ecceDeployments: { label: 'ECCE Deployments', page: 'Smart ECCE' },
  eccePillars: { label: 'ECCE Pillars', page: 'Smart ECCE' },
  villageJourney: { label: 'Village School Journey', page: 'Village Schools' },
  classroomModes: { label: 'Classroom Modes', page: 'Remote Classrooms' },
  netRakshakPillars: { label: 'NetRakshak Pillars', page: 'NetRakshak' },
  netRakshakArchitecture: { label: 'NetRakshak Architecture', page: 'NetRakshak' },
  techCapabilities: { label: 'Technology Capabilities', page: 'Technology' },
  contactInfo: { label: 'Contact Details', page: 'Contact / Footer' },
  annualReturns: { label: 'Annual Returns', page: 'Statutory Disclosures' },
};

const snapshot = {};
editableSections.forEach((k) => { snapshot[k] = null; });

export function captureDefaults(values) {
  editableSections.forEach((k) => { snapshot[k] = JSON.parse(JSON.stringify(values[k])); });
}

export function getDefaults() {
  return JSON.parse(JSON.stringify(snapshot));
}

export function applyContent(content) {
  if (!content) return;
  Object.entries(content).forEach(([k, v]) => {
    if (setters[k] && v != null) setters[k](v);
  });
}

captureDefaults({
  brand, transformCards, transformationChain, sevenEngines, conventionalVsTransformed,
  journeyStages, implementationSteps, ecceStats, ecceOutcomes, ecceDeployments, eccePillars,
  villageJourney, classroomModes, netRakshakPillars, netRakshakArchitecture, techCapabilities,
  contactInfo, evidenceStrip, siteImages, annualReturns,
});
